import { gql } from '@apollo/client'
import { TypedDocumentNode } from '@graphql-typed-document-node/core'
import {
  FcFinSimpleGrowProfileAccountsByMcnQuery,
  FcFinSimpleGrowProfileAccountsByMcnQueryVariables,
  FcFinSimpleGrowProfileCustomerAccountRelationQuery,
  FcFinSimpleGrowProfileCustomerAccountRelationQueryVariables,
} from '@src/__generated__/graphql'

export const CUSTOMER_DATA_QUERY: TypedDocumentNode<
  FcFinSimpleGrowProfileAccountsByMcnQuery,
  FcFinSimpleGrowProfileAccountsByMcnQueryVariables
> = gql`
  query FcFinSimpleGrowProfileAccountsByMCN($mcn: fc__customer__MCN!, $masterCustomerNumber: Int!, $country: Country!) {
    fmcc {
      account {
        accountsByMCN(mcn: $mcn) {
          accountNumber
          companyBusinessCode
          applicantType
          vehicleIdentificationNumber
          vehicleNickname
          vehicleMake
          vehicleModel
          vehicleYear
          accountStatus
          accountStatusCode
          garagingAddress {
            addressLine1
            addressLine2
            city
            state
            zip
            country
          }
        }
      }
      payment {
        multiPaymentInformation(masterCustomerNumber: $masterCustomerNumber, country: $country) {
          multiPaymentAccountInformation {
            account {
              id
            }
            paymentEligibilityDetails {
              isCombinedBillingAccount
              isAutoPayEnrolled
              isPayrollDeduct
              isInBankruptcy
              isAccountClosed
            }
          }
        }
      }
    }
  }
`

export const PROFILE_INFORMATION_QUERY: TypedDocumentNode<
  FcFinSimpleGrowProfileCustomerAccountRelationQuery,
  FcFinSimpleGrowProfileCustomerAccountRelationQueryVariables
> = gql`
  query FcFinSimpleGrowProfileCustomerAccountRelation(
    $accountNumber: fmcc__account__AccountNumber!
    $applicantCode: ApplicantCode!
  ) {
    fmcc {
      customer {
        customerAccountRelation(accountNumber: $accountNumber, applicantCode: $applicantCode) {
          account {
            id
            garagingAddress {
              addressLine1
              addressLine2
              city
              state
              zip
              country
            }
          }
          customerProfile {
            id
            firstName
            lastName
            companyName
            digitalCommunications {
              text
            }
            billingAddress {
              addressLine1
              addressLine2
              country
              city
              state
              zip
            }
            phoneNumbers {
              phoneNumber
              extension
              phoneType
              phoneLocation
              phoneCategory
              sequenceNumber
              phoneIDNumber
            }
          }
          notificationPreferences {
            customerPreferredChannel
            customerPreferences {
              channel
              permission
              permissionType
              paymentReminderDaysPrior
              phoneValidated
              phoneIdNumber
            }
            accountPreferences {
              preferences {
                channel
                permission
                permissionType
                paymentReminderDaysPrior
                phoneValidated
                phoneIdNumber
                permissionHistory {
                  actualRequestTimestamp
                  updateTimestamp
                }
              }
              account {
                id
              }
            }
          }
        }
      }
    }
  }
`
